var app;
(function (app) {
    "use strict";
    var mainApp = angular.module("jcsfApp", ["ui.router",
        'ngSanitize', 'ngCsv',
        'ngCookies', 'ngMask']);
    mainApp.config(['$stateProvider', '$urlRouterProvider',
        function ($stateProvider, $urlRouterProvider) {
            $urlRouterProvider.otherwise("/");
            $stateProvider
                .state('home', {
                    name: 'home',
                    url: '/',
                    templateUrl: "/app/public/views/home.html",
                    data: { requiresIdentity: true }
                })
                .state('redir', {
                    name: 'redir',
                    url: '/redir',
                    templateUrl: "/app/authentication/views/redir.html",
                    controller: "redirController as vm",
                    data: { requiresIdentity: false }
                })
                .state("forestService", {
                    name: 'forestService',
                    url: "/forestService/:id/:cid",
                    templateUrl: "/app/forestService/views/forestService.html",
                    controller: "forestServiceController as vm",
                    data: { requiresIdentity: false }
                })
                .state("forestServices", {
                    name: 'forestServices',
                    url: "/forestServices",
                    templateUrl: "/app/forestService/views/forestServiceList.html",
                    controller: "forestServiceProjectsController as vm",
                    data: { requiresIdentity: false }
                })
                .state("forestServicesCenter", {
                    name: 'forestServicesCenter',
                    url: "/forestServices/:id",
                    templateUrl: "/app/forestService/views/forestServiceList.html",
                    controller: "forestServiceProjectsController as vm",
                    data: { requiresIdentity: false }
                })
                .state("projects", {
                    name: 'projects',
                    url: "/projects",
                    templateUrl: "/app/projects/views/projects.html",
                    controller: "projectsController as vm",
                    data: { requiresIdentity: true }
                })
                .state("projectscenter", {
                    name: 'projectscenter',
                    url: "/projects/:id",
                    templateUrl: "/app/projects/views/projects.html",
                    controller: "projectsController as vm",
                    data: { requiresIdentity: true }
                })
                .state('project', {
                    name: 'project',
                    url: "/project/:id",
                    templateUrl: "/app/projects/views/project.html",
                    controller: "projectController as vm",
                    data: { requiresIdentity: true }
                })
                .state("nonpublicprojects", {
                    name: 'nonpublicprojects',
                    url: "/nonpublicprojects",
                    templateUrl: "/app/nonpublicprojects/views/nonpublicprojects.html",
                    controller: "nonpublicprojectsController as vm",
                    data: { requiresIdentity: false }
                })
                .state('nonpublicproject', {
                    name: 'nonpublicproject',
                    url: "/nonpublicproject/:id",
                    templateUrl: "/app/nonpublicprojects/views/nonpublicproject.html",
                    controller: "nonpublicprojectController as vm",
                    data: { requiresIdentity: true }
                })
                .state("students", {
                    name: 'students',
                    url: "/students",
                    templateUrl: "/app/students/views/students.html",
                    controller: "studentsController as vm",
                    data: { requiresIdentity: false }
                })
                .state("studentsArchive", {
                    name: 'studentsArchive',
                    url: "/students/archive",
                    templateUrl: "/app/students/views/studentsArchive.html",
                    controller: "studentsController as vm",
                    data: { requiresIdentity: false }
                })
                .state("studentsCenter", {
                    name: 'studentsCenter',
                    url: "/students/:id",
                    templateUrl: "/app/students/views/students.html",
                    controller: "studentsController as vm",
                    data: { requiresIdentity: false }
                })
                .state('student', {
                    name: 'student',
                    url: "/student/:id",
                    templateUrl: "/app/students/views/student.html",
                    controller: "studentController as vm",
                    data: { requiresIdentity: true }
                })
                .state('studentCtr', {
                    name: 'student',
                    url: "/studentCtr/:id/:ctr",
                    templateUrl: "/app/students/views/student.html",
                    controller: "studentController as vm",
                    data: { requiresIdentity: true }
                })
                .state("rsas", {
                    name: 'rsas',
                    url: "/rsas",
                    templateUrl: "/app/rsas/views/rsas.html",
                    controller: "rsasController as vm",
                    data: { requiresIdentity: false }
                })
                .state('rsa', {
                    name: 'rsa',
                    url: "/rsa/:id",
                    templateUrl: "/app/rsas/views/rsa.html",
                    controller: "rsaController as vm",
                    data: { requiresIdentity: true }
                })
                .state("centers", {
                    name: 'centers',
                    url: "/centers",
                    templateUrl: "/app/jccenters/views/jccenters.html",
                    controller: "jccentersController as vm",
                    data: { requiresIdentity: false }
                })
                .state('center', {
                    name: 'center',
                    url: "/center/:id",
                    templateUrl: "/app/jccenters/views/jccenter.html",
                    controller: "jccenterController as vm",
                    data: { requiresIdentity: true }
                })

                .state("reports", {
                    name: 'reports',
                    url: "/reports",
                    templateUrl: "/app/reports/views/reportSummaries.html",
                    controller: "reportsController as vm",
                    data: { requiresIdentity: true }
                })
                .state("members", {
                    name: 'members',
                    url: "/members",
                    templateUrl: "/app/membership/views/users.html",
                    controller: "UsersController as vm",
                    data: { requiresIdentity: true }
                })

                .state('member', {
                    name: 'member',
                    url: "/member/:id/edit",
                    templateUrl: "/app/membership/views/user.html",
                    controller: "UserController as vm",
                    data: { requiresIdentity: true }
                })
                .state('memberadd', {
                    name: 'memberadd',
                    url: "/member/add",
                    templateUrl: "/app/membership/views/addUser.html",
                    controller: "AddUserController as vm",
                    data: { requiresIdentity: true }
                })
                .state("profile", {
                    name: 'profile',
                    url: '/profile',
                    templateUrl: "/app/profile/views/profile.html",
                    controller: "ProfileController as vm",
                    data: { requiresIdentity: true }
                })
                .state("forbidden", {
                    name: 'forbidden',
                    url: '/forbidden',
                    templateUrl: "/app/authentication/views/forbidden.html",
                    controller: "ErrorHandlerController as vm"
                })
                .state("notAuthorized", {
                    name: 'notAuthorized',
                    url: '/notAuthorized',
                    templateUrl: "/app/authentication/views/notAuthorized.html",
                    controller: "ErrorHandlerController as vm"
                })
                .state("invalidCredentials", {
                    name: 'invalidCredentials',
                    url: '/invalidCredentials',
                    templateUrl: "/app/authentication/views/invalidCredentials.html",
                    controller: "ErrorHandlerController as vm"
                })
                .state("notFound", {
                    name: 'notFound',
                    url: '/notFound',
                    templateUrl: "/app/authentication/views/404.html",
                    controller: "ErrorHandlerController as vm"
                })
                .state("onlinehelp", {
                    name: 'onlinehelp',
                    url: '/onlinehelp',
                    templateUrl: "/app/public/views/onlinehelp.html",
                    data: { requiresIdentity: false }
                });
        }]);
    mainApp.run(['$window', '$http', '$rootScope', '$state', '$stateParams', 'PermissionService', 'authService', '$location', 'valuesService',
        function ($window, $http, $rootScope, $state, $stateParams, permissionsService, authService, $location, valuesService) {
            $rootScope.goBack = function () {
                $window.history.back();
            };
            $rootScope.$state = $state;
            $rootScope.$stateParams = $stateParams;
            $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                var toStateData = toState.data || {};
                if (toStateData.requiresIdentity && authService.authentication.isAuth === false) {
                    authService.logOut();
                    if (fromState.url !== '^') {
                        $location.path(fromState.url);
                        event.preventDefault();
                    }
                    else {
                        $location.path("/");
                    }
                }
                else if (toStateData.role !== null && toStateData.role !== undefined &&
                    ($rootScope.hasPermission === null || $rootScope.hasPermission === undefined || !$rootScope.hasPermission(toStateData.role))) {
                    authService.logOut();
                    $location.path("/notAuthorized");
                }
                else if ($location.path() === "/" && authService.authentication.isAuth) {
                    $location.path("/");
                }
            });
            $rootScope.$on('$stateChangeSuccess', function () {
                $rootScope.pageTitle = $state.current.title;
            });
        }]);
    mainApp.config(['$httpProvider', function ($httpProvider) {
        $httpProvider.interceptors.push('AuthInterceptorService');
    }]);
    mainApp.run([
            '$http', '$cookies', '$cookieStore', '$rootScope', '$state', '$stateParams',
        function ($http, $cookies, $cookieStore, $rootScope, $state, $stateParams) {
            $http.defaults.headers.common.Authorization = 'Bearer ' + $cookieStore.get('_Token');
            $rootScope.$state = $state;
            $rootScope.$stateParams = $stateParams;
            $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
            });
            $rootScope.$on('$stateChangeSuccess', function () {
                $rootScope.pageTitle = $state.current.title;
            });
            String.prototype.toProperCase = function () {
                return this.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
            };
            Number.prototype.pad = function (size) {
                var s = String(this);
                while (s.length < (size || 2)) {
                    s = "0" + s;
                }
                return s;
            };
            Array.prototype.keySort = function (key, desc) {
                var ar = this;
                ar.sort(function (a, b) {
                    var result = desc ? a[key] < b[key] : a[key] > b[key];
                    return result ? 1 : -1;
                });
                return ar;
            };
            if (!('contains' in String.prototype)) {
                String.prototype.contains = function (str, startIndex) {
                    return ''.indexOf.call(this, str, startIndex) !== -1;
                };
            }
            if (!('replaceAll' in String.prototype)) {
                String.prototype.replaceAll = function (s, r) { return this.split(s).join(r); };
                String.prototype.generateUUId = function () {
                    var d = new Date().getTime();
                    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                        var r = (d + Math.random() * 16) % 16 || 0;
                        d = Math.floor(d / 16);
                        return (c === 'x' ? r : r && 0x3 || 0x8).toString(16);
                    });
                    return uuid;
                };
                String.prototype.camelCaseToWords = function () {
                    return this.replace(/([A-Z])/g, ' $1')
                        .replace(/^./, function (str) { return str.toUpperCase(); });
                };
                if (!String.prototype.startsWith) {
                    String.prototype.startsWith = function (prefix) {
                        return this.indexOf(prefix) === 0;
                    };
                }
                String.prototype.endsWith = function (suffix) {
                    return this.indexOf(suffix, this.length - suffix.length) !== -1;
                };
            }
        }
 ])
        .run(['errors', function (errors) { errors.init(); }])
        .run(['notification', function (notification) { notification.init(); }])
        .run(['authService', function (authService) { authService.init(); }])
        .run(['PermissionService', function (PermissionService) { PermissionService.init(); }])
        .run(['RSAsService', function (RSAsService) { RSAsService.init(); }])
        .run(['jcCenterService', function (jcCenterService) { jcCenterService.init(); }])
        .run(['studentsService', function (studentsService) { studentsService.init(); }])
        .run(['nonpublicprojectsService', function (nonpublicprojectsService) { nonpublicprojectsService.init(); }])
        .run(['projectsService', function (projectsService) { projectsService.init(); }])
        .run(['forestService', function (forestService) { forestService.init(); }])
        .run(['reportsService', function (reportsService) { reportsService.init(); }]);
})(app || (app = {}));
